import SencorIcon from './component'

export default SencorIcon
